import Icon from "@/components/icons";
import { BaseTagProps } from "@/components/Tags/types";

const defaultColorMap = {
  lightFern: "",
  fern: "border-primary-500 bg-[#BEF4E5] text-primary",
  pink: "border-accent-pink bg-[#ECDBE0] text-primary",
  putty: "border-putty-400 bg-putty-200 text-primary",
  orange: "border-brand-500 bg-brand-500 text-white",
};

const borderlessColorMap = {
  lightFern: "border-secondary-100 bg-secondary-100 text-primary",
  fern: "border-secondary-500 bg-secondary-500 text-white",
  pink: "border-accent-pink bg-accent-pink text-primary",
  putty: "border-putty-400 bg-putty-400 text-primary",
  orange: "border-brand-500 bg-brand-500 text-white",
};

type TagProps = BaseTagProps & {
  title: string;
  className?: string;
};

const Tag = ({
  title,
  icon,
  color = "putty",
  borderless = false,
  className = "",
}: TagProps) => {
  const colors = borderless
    ? borderlessColorMap[color]
    : defaultColorMap[color];
  return (
    <div
      className={`flex items-center justify-center gap-1 rounded-sm border-2 ${colors} ${className}`}
    >
      {icon && <Icon type={icon} svgProps={{ height: 14, width: 14 }} />}
      {title}
    </div>
  );
};

export default Tag;
